/*jshint unused:false*/
/*global fetch */
/*global console */

//object fit fix for ie11
var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);


if (ie) {
  var imgContainer = document.querySelectorAll(".img-container");

  for (var i = 0; i < imgContainer.length; i++) {
    var imgCtr = imgContainer[i];
    var imgUrl = imgCtr.getElementsByTagName("img")[0].src;
    if (imgUrl) {
      imgCtr.setAttribute("style", "background-image:url('" + imgUrl + "')");
      imgCtr.classList.add("custom-object-fit");
    }
  }
}

// Back to top button
if(document.getElementById('back_to_top')){
  const scrollToTopButton = document.getElementById('back_to_top');
  let smoothScrollCapture = (x) => {
    event.preventDefault();
    let id = x.currentTarget.target.getAttribute('href').split("#")[1]
    let el = document.getElementById(id);
    var x = el.getBoundingClientRect().left;
    var y = el.getBoundingClientRect().top;
    smoothScrollFunc(x, y)
  }
  let smoothScrollFunc = (x, y) => {
    event.preventDefault();
    window.scrollTo({
      top: y,
      left: x,
      behavior: 'smooth'
    });
  }
  window.addEventListener('DOMContentLoaded', () => {
    scrollToTopButton.addEventListener('click', () => {
      smoothScrollFunc(0, 0);
    })
  })


  window.addEventListener('scroll', () => {
    let pageHeight = document.body.scrollHeight;
    let currentHeight = window.scrollY;
    (currentHeight > (pageHeight / 2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
  })
}
// End back to top button

//Nav Toggle
function toggleNav(el) {
  var element = el;
  var menu = document.getElementById("site-menu");
  var header = document.querySelectorAll(".site-header")[0];
  menu.classList.toggle("active");
  header.classList.toggle("active");

  if (element.querySelector("span").classList.contains("more")) {
    element.innerHTML = "<span class='close'></span> Close";
  } else {
    element.innerHTML = "<span class='more'></span> Menu";
  }
}

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav', 'reversed'],
  onOpen: function () {
    // Navigation height
    let headerHeight = 0;
    if (document.querySelector('.site-header').classList.contains('is-sticky')) {
      headerHeight = document.querySelector('.site-header').offsetHeight;
    } else {
      headerHeight = document.querySelector('.site-header').offsetHeight + (document.body.getBoundingClientRect().top + window.scrollY);
    }
    document.querySelector('.mobile-nav.tingle-modal').setAttribute('style', `margin-top:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
  }
});
document.querySelector('.site-menu') ? modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML + document.querySelector('.header-buttons').outerHTML) : null;

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');
  // hamburger.parentElement.classList.toggle('active');

  if (hamburger.classList.contains("active")) {
    // modalMobileSearch.close();
    modalMobileNav.open();
  } else {
    modalMobileNav.close();
  }
}

if (hamburger) {
  hamburger.onclick = () => handleToggle();
  hamburger.addEventListener('keyup', (event) => {
    if (event.keyCode === 13 || event.keyCode === 32) {
      handleToggle();
    }
  });
}
/* END MOBILE MODALS */

// Show More
const showMoreButton = document.querySelector('#show-more');
const headerContent = document.querySelector('#manufacturer-header-content');
if (showMoreButton) {
  if (showMoreButton.parentElement.querySelectorAll('.header-description > *').length > 1) {
    showMoreButton.addEventListener('click', (e) => {
      console.log('click')
      headerContent.classList.toggle('header-content--full');
      showMoreButton.classList.toggle('active');
      (showMoreButton.classList.contains('active')) ? showMoreButton.querySelector('span').innerText = 'Show less' : showMoreButton.querySelector('span').innerText = 'Read more';
    })
  } else {
    showMoreButton.classList.add('visuallyhidden')
  }
}

//Site Menu Dropdown Toggle
var menuDropdown = function () {
  //div inside element contains dropdown menu
  var dropdown = this.parentNode;

  //if it's already active set it not to be
  if (dropdown.classList.contains("active")) {
    dropdown.classList.toggle("active");
    return;
  }
  //get current active class
  var activeClass = document.querySelectorAll(".menu-dropdown.active");
  // make it not active
  if (activeClass != null) {
    for (var i = 0; i < activeClass.length; i++) {
      activeClass[i].classList.toggle("active");
    }
  }

  //apply active to the div inside element that contains dropdown menu
  dropdown.classList.toggle("active");
}

var dropdownTrigger = document.querySelectorAll(".menu-dropdown > a");

for (var i = 0; i < dropdownTrigger.length; i++) {
  dropdownTrigger[i].addEventListener('click', menuDropdown, false);
}


//Dropdown Menu Toggle
var showMenu = function () {
  //div inside element contains dropdown menu
  var dropdown = this.parentNode.querySelector('div');
  var menuToggle = this;

  //if it's already active set it not to be
  if (dropdown.classList.contains("active")) {
    dropdown.classList.toggle("active");
    menuToggle.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("is-active");
    return;
  }
  //get current active class
  var activeClass = document.querySelectorAll(".dropdown-menu .active");
  // make it not active
  if (activeClass != null) {
    for (var i = 0; i < activeClass.length; i++) {
      activeClass[i].classList.toggle("active");
      activeClass[i].classList.toggle("is-active");
    }
  }

  //apply active to the div inside element that contains dropdown menu
  dropdown.classList.toggle("active");
  dropdown.classList.toggle("is-active");
  menuToggle.classList.toggle("active");
  menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for (var i = 0; i < menuDropdown.length; i++) {
  menuDropdown[i].addEventListener('click', showMenu, false);
}

// Toggle class for accordions
let acc = document.getElementsByClassName('mobile-accordion-header');
for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function (ev) {

    for (let i = 0; i < acc.length; i++) {
      if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
        continue;
      }
      acc[i].parentElement.classList.remove('active');
    }

    if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')) {
      setTimeout(() => {
        document.documentElement.scrollTop += this.getBoundingClientRect().top;
      }, 500);
    }
    this.parentElement.classList.toggle("active");

  });
}

// faqs
var faqSearch = document.querySelector('.faq-search input');

if (faqSearch !== null) {
  faqSearch.addEventListener('keyup', function (e) {
    var results = document.getElementById('faq-results');
    if (this.value.length != 0) {
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {

  // Auto-slide helper function
  function sliderAuto(slider, milliseconds) {
    const slidesCount = slider.track.childElementCount;
    let slideTimeout = null;
    let nextIndex = 1;

    function slide() {
      slideTimeout = setTimeout(
        function () {
          if (nextIndex >= slidesCount) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        },
        milliseconds
      );
    }

    slider.ele.addEventListener('glider-animated', function () {
      window.clearInterval(slideTimeout);
      slide();
    });

    slide();
  }

  // Review Slider
  const reviewSlider = document.querySelector('.review-strip .review-list');
  if (reviewSlider) {
    new Glider(reviewSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    })
  }
  // END Review Slider

  // Login Review Slider
  const loginSlider = document.querySelector('.login-review .review-list');
  if (loginSlider) {
    const glider = new Glider(loginSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: false,
      scrollLock: true
    });
    sliderAuto(glider, 8000);
  }
  // END Review Slider


  // Review Video Modals
  const videoModal = new tingle.modal({
    footer: false,
    closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: "Close",
    cssClass: ['video-modal'],
    onClose: function () {
      this.setContent('');
    }
  });
  document.querySelectorAll('.video-modal').forEach(function (review) {
    review.addEventListener("click", function (e) {
      let videoType = review.getAttribute('data-video-type');
      let videoId = review.getAttribute('data-video-id');
      if (videoId) {
        if (videoType === 'vimeo') {
          videoModal.setContent(`
          <div class="iframe-wrapper">
            <iframe width="560" height="315" src="https://player.vimeo.com/video/${videoId}?autoplay=1&amp;title=0&amp;byline=0&amp;portrait=0" frameBorder="0" allowFullScreen></iframe>
          </div>
        `);
        } else {
          videoModal.setContent(`
          <div class="iframe-wrapper">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/${videoId}" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        `);
        }
        videoModal.open();
      }
    })
  })
  // END Review Video Modals

  // Scan Results Image Modals
  const imageModal = new tingle.modal({
    footer: false,
    closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: "Close",
    cssClass: ['image-modal'],
    onClose: function () {
      this.setContent('');
    }
  });
  document.querySelectorAll('.panel-img:not(.no-hover)').forEach(function (review) {
    review.addEventListener("click", function (e) {
      let src = this.dataset.url;
      imageModal.setContent(`
          <div class="panel-img">
              <picture>
                  <img src="`+src+`"
                       alt=""
                       loading="lazy"
                       width="100"
                       height="100"
                  />
              </picture>
          </div>
        `);

      imageModal.open();
    })
  })
  document.querySelectorAll('.scan-image-btn').forEach(function (review) {
    review.addEventListener("click", function (e) {
      let src = this.dataset.url;
      imageModal.setContent(`
          <div class="panel-img">
              <picture>
                  <img src="`+src+`"
                       alt=""
                       loading="lazy"
                       width="100"
                       height="100"
                  />
              </picture>
          </div>
        `);

      imageModal.open();
    })
  })
  // END Scan Results Image

  // Update images in manual damage addition

  const select_image = document.getElementById("selected-image-library");
  if (select_image) {
    document.getElementById("selected-image-library").addEventListener("click", function(event) {
      let clickedImg = event.target.closest(".panel-img.no-hover");
      if (!clickedImg) return;
  
      let imageUrl = clickedImg.getAttribute("data-url");
      let inputField = document.getElementById("selected_image");
  
      if (clickedImg.classList.contains("selected")) {
        clickedImg.classList.remove("selected");
        if (inputField) {
          inputField.value = "";
        }
      } else {
  
        document.querySelectorAll(".panel-img.no-hover").forEach(img => img.classList.remove("selected"));
        clickedImg.classList.add("selected");
  
        if (inputField) {
          inputField.value = imageUrl;
        }
      }
    });
  }
  // END Update images in manual damage addition

  //Images Animations
  const home = document.querySelector(".page-home");
  const homePhone = document.getElementById('phone-home');
  const howItWorks = document.querySelector(".page-how-it-works");
  const howItWorksPhone = document.getElementById('phone-how-it-works');

  if (home && homePhone) {
    home.addEventListener("mousemove", function (event) {

      let width = (-(event.pageX * 0.0152222)) + "px";
      let height = (-(event.pageY * 0.0228888)) + "px";

      homePhone.style.transform = "translate3d(" + width + ", " + height + ", " + "0px)";
      homePhone.style.transformStyle = "preserve-3d";
      homePhone.style.backfaceVisibility = "hidden";
      homePhone.style.transition = "all .15s ease";

    });
  }

  if (howItWorks && howItWorksPhone) {
    howItWorks.addEventListener("mousemove", function (event) {

      let width = (-(event.pageX * 0.0152222) + 20) + "px";
      let height = (-(event.pageY * 0.0228888)) + "px";

      howItWorksPhone.style.transform = "translate3d(" + width + ", " + height + ", " + "0px)";
      howItWorksPhone.style.transformStyle = "preserve-3d";
      howItWorksPhone.style.backfaceVisibility = "hidden";
      howItWorksPhone.style.transition = "all .15s ease";

    });
  }
//END Images Animations

  //Number Counter
  let element = document.getElementById('basic-waypoint');
  if(element){
    let waypoint = new Waypoint({
      element: document.getElementById('basic-waypoint'),
      handler: function (startCounting) {

        const counters = document.querySelectorAll('.about-number');

        counters.forEach((counter) => {
          anime({
            targets: counter,
            innerHTML: [0, counter.getAttribute('data-count')],
            easing: 'easeInOutSine',
            round: 1,
            duration: 2800,
          })
        });

        console.log(this.element.offset);

        this.destroy();
      },
      offset: '85%'
    })
  }

  //Move Dot On Scroll
  // if (document.getElementById("newsletter-circle-yellow")){
  //   let elementLocation = document.getElementById("newsletter-circle-yellow").getBoundingClientRect();
  //   let offsetToTriggerAnimation = elementLocation.y;
  //   let maxMove = 40;
  //   function scrollAnimTriggerCheck(evt) {
  //     let viewBottom = window.scrollY + window.innerHeight;
  //     if (viewBottom > offsetToTriggerAnimation) {
  //       if(((viewBottom - offsetToTriggerAnimation) * 0.01) > maxMove){
  //         document.getElementById("newsletter-circle-yellow").style.left = `-${maxMove}px`;
  //       } else {
  //         document.getElementById("newsletter-circle-yellow").style.left = `-${(viewBottom - offsetToTriggerAnimation) * 0.01}px`;
  //       }
  //     }
  //   }
  //
  //   document.addEventListener("scroll", scrollAnimTriggerCheck);
  // }
  //
  // let yelloCircle = new Waypoint({
  //   element: document.getElementById('newsletter-circle-yellow'),
  //   handler: function (startCounting) {
  //
  //     console.log(this.element.offsetTop);
  //   },
  //   offset: '85%'
  // })

  // Show More Images
  const showMoreBtn = document.querySelector('.image-library-btn #show-more-btn');
  const imageLibraryWrapper = document.querySelector('#image-library');
  if (showMoreBtn && imageLibraryWrapper) {
    var show_more = 'Show More';
    var show_less = 'Show Less';
    let url = '/translations/translate';

    fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({'show_more' : 'Show More','show_less' : 'Show Less','_token':document.querySelector(
            'input[name="_token"]').value  })
    })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          // Check if the response were success
          show_more = 'Show More';
          show_less = 'Show Less';
          if(data.status=='ok'){
            show_more = data.more ?? 'Show More';
            show_less = data.less ?? 'Show Less';
          }
        })
        .catch(function (error){
          show_more = 'Show More';
          show_less = 'Show Less';
        });


    showMoreBtn.addEventListener('click', (e) => {



      imageLibraryWrapper.classList.toggle('active');
      showMoreBtn.classList.toggle('active');
      (showMoreBtn.classList.contains('active')) ? showMoreBtn.querySelector('span').innerText = show_less : showMoreBtn.querySelector('span').innerText = show_more;
    })
  }
  // if (showMoreBtn) {
  //   console.log('0')
  //   if (imageLibraryWrapper.scrollHeight >= 310) {
  //     console.log('1')
  //     console.log(imageLibraryWrapper.scrollHeight >= 310)
  //     showMoreBtn.classList.remove('visuallyhidden')
  //     showMoreBtn.addEventListener('click', (e) => {
  //       imageLibraryWrapper.classList.toggle('active');
  //       showMoreBtn.classList.toggle('active');
  //       (showMoreBtn.classList.contains('active')) ? showMoreBtn.querySelector('span').innerText = 'Show less' : showMoreBtn.querySelector('span').innerText = 'Show more';
  //     })
  //
  //   } else {
  //     console.log('2')
  //     showMoreBtn.classList.add('visuallyhidden')
  //   }
  // }


  //Price display dropdown

    const priceDropdown = document.querySelector('#price-display');

    const tableRows = document.querySelectorAll('.damage-report-table .table-row');

    const elements = {
      min: [
        ...document.querySelectorAll('.damage-report-table .heading-min'),
        ...document.querySelectorAll('.damage-report-table .min-cost'),
        ...document.querySelectorAll('.damage-report-table .list-min'),
        ...document.querySelectorAll('.damage-report-table .footer-min'),
        ...document.querySelectorAll('.scan-estimate-inner .heading-min'),
        ...document.querySelectorAll('.scan-estimate-inner .min-cost'),
        ...document.querySelectorAll('.scan-estimate-inner .list-min'),
        ...document.querySelectorAll('.scan-estimate-inner .footer-min')
      ],
      max: [
        ...document.querySelectorAll('.damage-report-table .heading-max'),
        ...document.querySelectorAll('.damage-report-table .max-cost'),
        ...document.querySelectorAll('.damage-report-table .max-cost-full'),
        ...document.querySelectorAll('.damage-report-table .list-max'),
        ...document.querySelectorAll('.damage-report-table .footer-max'),
        ...document.querySelectorAll('.scan-estimate-inner .heading-max'),
        ...document.querySelectorAll('.scan-estimate-inner .max-cost'),
        ...document.querySelectorAll('.scan-estimate-inner .max-cost-full'),
        ...document.querySelectorAll('.scan-estimate-inner .list-max'),
        ...document.querySelectorAll('.scan-estimate-inner .footer-max')
      ],
      range: [
        ...document.querySelectorAll('.damage-report-table .heading-range'),
        ...document.querySelectorAll('.damage-report-table .range-cost'),
        ...document.querySelectorAll('.damage-report-table .list-range'),
        ...document.querySelectorAll('.damage-report-table .footer-range'),
        ...document.querySelectorAll('.scan-estimate-inner .heading-range'),
        ...document.querySelectorAll('.scan-estimate-inner .range-cost'),
        ...document.querySelectorAll('.scan-estimate-inner .list-range'),
        ...document.querySelectorAll('.scan-estimate-inner .footer-range')
      ],
      average: [
        ...document.querySelectorAll('.damage-report-table .heading-average'),
        ...document.querySelectorAll('.damage-report-table .average-cost'),
        ...document.querySelectorAll('.damage-report-table .list-average'),
        ...document.querySelectorAll('.damage-report-table .footer-average'),
        ...document.querySelectorAll('.scan-estimate-inner .heading-average'),
        ...document.querySelectorAll('.scan-estimate-inner .average-cost'),
        ...document.querySelectorAll('.scan-estimate-inner .list-average'),
        ...document.querySelectorAll('.scan-estimate-inner .footer-average')
      ]
    };

    if (priceDropdown) {

      var price_value = document.querySelector('#price-display-value');
      var price_display = price_value.dataset.value;

      if (!price_display || price_display === 'default') {
        price_display = 'range';
      }

      // const value = priceDropdown.value;
      const visuallyhidden = 'visuallyhidden';

      // Hide all elements initially
      Object.keys(elements).forEach(key => {
        elements[key].forEach(element => element.classList.add(visuallyhidden));
      });

      // Show elements based on the selected value
      if (price_display === 'default') {
        elements.min.forEach(element => element.classList.remove(visuallyhidden));
        elements.max.forEach(element => element.classList.remove(visuallyhidden));
      } else {
        elements[price_display].forEach(element => element.classList.remove(visuallyhidden));
      }

      // Manage table row classes
      tableRows.forEach(row => {
        if (price_display === 'default') {
          row.classList.remove('show-one-price');
          row.classList.add('default');
        } else {
          row.classList.remove('default');
          row.classList.add('show-one-price');
        }
      });
    }

    // Adjust Damage Report Table styling based on number of columns
    const damageReportTables = document.querySelectorAll('.damage-report-table');

    if (damageReportTables) {
        damageReportTables.forEach((table, index) => {
            // Find the number of visible columns in the header
            const visibleColumns = table.querySelectorAll('.table-head .table-row > div:not(.visuallyhidden)');
            console.log(`Table ${index + 1} has ${visibleColumns.length} visible columns.`);

            // Adjust the column count for the grid-template-columns by subtracting 3 columns with different sizes
            let adjustedColumns = visibleColumns.length - 3;

            // Check if the last visible column has the class 'heading-remove-damage'
            const lastVisibleColumn = visibleColumns[visibleColumns.length - 1];
            const hasRemoveDamageClass = lastVisibleColumn && lastVisibleColumn.classList.contains('heading-remove-damage');

            // For each .table-row inside the current table, set the grid-template-columns style
            const tableRows = table.querySelectorAll('.table-row');
            tableRows.forEach((row) => {
                if (adjustedColumns < 1) {
                    // Fallback when the number of all visible columns is less than 4
                    row.style.gridTemplateColumns = `2fr 1fr .6fr`;
                } else {
                    // If the last column has 'heading-remove-damage', use '30px', otherwise use '.6fr'
                    const lastColumnWidth = hasRemoveDamageClass ? '30px' : '.6fr';
                    row.style.gridTemplateColumns = `2fr 1fr repeat(${adjustedColumns}, .6fr) ${lastColumnWidth}`;
                }
            });
        });
    }


});

// Contact Form
if (document.getElementById('send-contact-form')) {
  // Do captcha and submit form
  document.getElementById('send-contact-form').addEventListener("click", function (e) {
    e.preventDefault();

    document.body.classList.remove('loaded');
    let button = document.querySelector('#send-contact-form');
    button.disabled = true;
    button.innerHTML = 'Sending...';

    grecaptcha.ready(function () {
      grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function (recaptcha_token) {
        document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

        let url = '/contact';
        let email = document.querySelector('#contact-form [name=email]').value;
        let forename = document.querySelector('#contact-form [name=forename]').value;
        let surname = document.querySelector('#contact-form [name=surname]').value;
        let telephone = document.querySelector('#contact-form [name=telephone]').value;
        let company = document.querySelector('#contact-form [name=company]').value;
        let comments = document.querySelector('#contact-form [name=comments]').value;
        let type = document.querySelector('#contact-form [name=type]').value;
        let csrf_token = document.querySelector('#contact-form [name=_token]').value;

        fetch(url, {
          method: 'POST',
          body: JSON.stringify({
            'type': type,
            'name': forename + ' ' + surname,
            'forename': forename,
            'surname': surname,
            'email': email,
            'company': company,
            'telephone': telephone,
            'comments': comments,
            '_token': csrf_token,
            'g-recaptcha-response': recaptcha_token
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          document.body.classList.add('loaded');
          button.disabled = false;
          button.innerHTML = 'Submit Enquiry';
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }
          return response.json();
        }).then(function (data) {
          if (data.status !== 'ok') {
            let errors = '';
            for (var i in data.errors) {
              errors += data.errors[i][0] + '\n';
            }
            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            return alert('There was a problem with your form\n\n' + errors);
          }

          button.disabled = false;
          button.innerHTML = 'Submit Enquiry';
          document.getElementsByClassName('contact-form')[0].reset();
          document.getElementsByClassName('contact-content')[0].classList.add('hidden');
          document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
          document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

          // Trigger event tracking
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'General Enquiry Received'
          });


        }).catch(function (err) {
          document.body.classList.add('loaded');
          console.error('Fetch Error -', err);
          return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
        });

      });
    });

  });
}

//Email Signup
if (document.getElementById('email-signup')) {

  let button = document.querySelector('#email-signup');
  let terms = document.querySelector('.newsletter-form [name=terms]');
  button.disabled = true;
  terms.onchange = function() {
    button.disabled = !this.checked;
  };

  document.getElementById('email-signup').addEventListener("click", function (e) {
    e.preventDefault();

    document.getElementById('email-signup').classList.add('preload');
    document.getElementById('email-signup').innerHTML = '<span>Please wait<span>';
    document.getElementById('email-signup').disabled = true;

    if (document.querySelector('.newsletter-form input[name=g-recaptcha-response]').value == "") {
      grecaptcha.ready(function () {
        grecaptcha.execute(document.querySelector('.newsletter-form').dataset['recaptcha'], {action: 'contact'}).then(function (recaptcha_token) {
          document.querySelector('.newsletter-form input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/newsletter';
          let email = document.getElementById('newsletter-email').value;
          let forename = document.getElementById('newsletter-forename').value;
          let surname = document.getElementById('newsletter-surname').value;
          // let name = 'Register Form';
          let token = document.querySelector('.newsletter-form [name=_token]').value;
          let newsletter_recaptcha = document.querySelector('.newsletter-form input[name=g-recaptcha-response]').value;

          fetch(url, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify({
              'name': forename+' '+surname,
              'forename': forename,
              'surname': surname,
              'email': email,
              '_token': token,
              'g-recaptcha-response': newsletter_recaptcha
            }), // data can be `string` or {object}!
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
              return;
            }
            return response.json();
          }).then(function (data) {
            document.getElementById('email-signup').classList.remove('preload');
            document.getElementById('email-signup').innerHTML = 'Register';
            document.getElementById('email-signup').disabled = false;

            if (data.status != 'ok') {
              let errors = '';
              for (let i in data.errors) {
                errors += data.errors[i][0] + '\n';
              }
              if (typeof Swal !== 'undefined') {
                return Swal.fire({
                  title: 'Whoops!',
                  html: ('There was a problem with your sign up details\n\n' + errors).replace(/\n/gi, '<br>'),
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              } else {
                return alert('There was a problem with your sign up details\n\n' + errors);
              }
            }

            document.getElementsByClassName('newsletter-form')[0].reset();
            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'Newsletter Form Submit'
            });

            if (typeof Swal !== 'undefined') {
              return Swal.fire({
                title: 'Thank you!',
                text: 'You\'re signed up!',
                icon: 'success',
                confirmButtonText: 'OK'
              });
            } else {
              return alert('Thank you!');
            }

          }).catch(function (err) {
            console.error('Fetch Error -', err);
            document.getElementById('email-signup').classList.remove('preload');
            document.getElementById('email-signup').innerHTML = 'Register';
            document.getElementById('email-signup').disabled = false;
          });
        });
      });
    }
  });
}


// region switcher 
if(document.querySelector('.region-switcher')){
  document.querySelector('.region-switcher').addEventListener('click', function(e){
    document.querySelector('.region-switcher').classList.toggle("active");
  });
}

window.onload = (function () {
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  
  // END Preloader

});

$(document).ready(function () {
  // When the button is clicked, initialize Select2
  $(document).on('click', '.show-manual-damage-form', function () {
    $('#damaged_part').select2({
      width: '100%',
      placeholder: "Please Select",
      allowClear: true
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // "Add Damage" button scroll up
  document.querySelectorAll('.show-manual-damage-form').forEach(button => {
    button.addEventListener('click', function() {
      const target = document.querySelector('#manual-damage-addition');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});